export const selectedItemsToProductsParser = ({
  selected,
  artifactType,
  frequency,
  purchaseType,
}) =>
  selected.map(el => ({
    artifactId: el.id,
    artifactType,
    productCategory: el.level,
    frequency,
    purchaseType,
  }));
